/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
; (function () {
    function n(n, t) { for (var r = -1, e = t.length, u = n.length; ++r < e;)n[u + r] = t[r]; return n } function t(n, t, r) { for (var e = -1, u = n.length; ++e < u;) { var o = n[e], i = t(o); if (null != i && (c === an ? i === i : r(i, c))) var c = i, f = o } return f } function r(n, t, r) { var e; return r(n, function (n, r, u) { return t(n, r, u) ? (e = n, false) : void 0 }), e } function e(n, t, r, e, u) { return u(n, function (n, u, o) { r = e ? (e = false, n) : t(r, n, u, o) }), r } function u(n, t) { return O(t, function (t) { return n[t] }) } function o(n) { return n && n.Object === Object ? n : null } function i(n) {
        return vn[n];
    } function c(n) { var t = false; if (null != n && typeof n.toString != "function") try { t = !!(n + "") } catch (r) { } return t } function f(n, t) { return n = typeof n == "number" || hn.test(n) ? +n : -1, n > -1 && 0 == n % 1 && (null == t ? 9007199254740991 : t) > n } function a(n) { if (Y(n) && !Pn(n)) { if (n instanceof l) return n; if (En.call(n, "__wrapped__")) { var t = new l(n.__wrapped__, n.__chain__); return t.__actions__ = N(n.__actions__), t } } return new l(n) } function l(n, t) { this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t } function p(n, t, r, e) {
        var u; return (u = n === an) || (u = xn[r],
            u = (n === u || n !== n && u !== u) && !En.call(e, r)), u ? t : n
    } function s(n) { return X(n) ? Fn(n) : {} } function h(n, t, r) { if (typeof n != "function") throw new TypeError("Expected a function"); return setTimeout(function () { n.apply(an, r) }, t) } function v(n, t) { var r = true; return $n(n, function (n, e, u) { return r = !!t(n, e, u) }), r } function y(n, t) { var r = []; return $n(n, function (n, e, u) { t(n, e, u) && r.push(n) }), r } function _(t, r, e, u) {
        u || (u = []); for (var o = -1, i = t.length; ++o < i;) {
            var c = t[o]; r > 0 && Y(c) && L(c) && (e || Pn(c) || K(c)) ? r > 1 ? _(c, r - 1, e, u) : n(u, c) : e || (u[u.length] = c);
        } return u
    } function g(n, t) { return n && qn(n, t, en) } function b(n, t) { return y(t, function (t) { return Q(n[t]) }) } function j(n, t, r, e, u) { return n === t ? true : null == n || null == t || !X(n) && !Y(t) ? n !== n && t !== t : m(n, t, j, r, e, u) } function m(n, t, r, e, u, o) {
        var i = Pn(n), f = Pn(t), a = "[object Array]", l = "[object Array]"; i || (a = kn.call(n), "[object Arguments]" == a && (a = "[object Object]")), f || (l = kn.call(t), "[object Arguments]" == l && (l = "[object Object]")); var p = "[object Object]" == a && !c(n), f = "[object Object]" == l && !c(t); return !(l = a == l) || i || p ? 2 & u || (a = p && En.call(n, "__wrapped__"),
            f = f && En.call(t, "__wrapped__"), !a && !f) ? l ? (o || (o = []), (a = J(o, function (t) { return t[0] === n })) && a[1] ? a[1] == t : (o.push([n, t]), t = (i ? I : q)(n, t, r, e, u, o), o.pop(), t)) : false : r(a ? n.value() : n, f ? t.value() : t, e, u, o) : $(n, t, a)
    } function d(n) { var t = typeof n; return "function" == t ? n : null == n ? cn : ("object" == t ? x : A)(n) } function w(n) { n = null == n ? n : Object(n); var t, r = []; for (t in n) r.push(t); return r } function O(n, t) { var r = -1, e = L(n) ? Array(n.length) : []; return $n(n, function (n, u, o) { e[++r] = t(n, u, o) }), e } function x(n) {
        var t = en(n); return function (r) {
            var e = t.length; if (null == r) return !e; for (r = Object(r); e--;) { var u = t[e]; if (!(u in r && j(n[u], r[u], an, 3))) return false } return true
        }
    } function E(n, t) { return n = Object(n), P(t, function (t, r) { return r in n && (t[r] = n[r]), t }, {}) } function A(n) { return function (t) { return null == t ? an : t[n] } } function k(n, t, r) { var e = -1, u = n.length; for (0 > t && (t = -t > u ? 0 : u + t), r = r > u ? u : r, 0 > r && (r += u), u = t > r ? 0 : r - t >>> 0, t >>>= 0, r = Array(u); ++e < u;)r[e] = n[e + t]; return r } function N(n) { return k(n, 0, n.length) } function S(n, t) {
        var r; return $n(n, function (n, e, u) {
            return r = t(n, e, u),
                !r
        }), !!r
    } function T(t, r) { return P(r, function (t, r) { return r.func.apply(r.thisArg, n([t], r.args)) }, t) } function F(n, t, r, e) { r || (r = {}); for (var u = -1, o = t.length; ++u < o;) { var i = t[u], c = e ? e(r[i], n[i], i, r, n) : n[i], f = r, a = f[i]; En.call(f, i) && (a === c || a !== a && c !== c) && (c !== an || i in f) || (f[i] = c) } return r } function R(n) { return V(function (t, r) { var e = -1, u = r.length, o = u > 1 ? r[u - 1] : an, o = typeof o == "function" ? (u--, o) : an; for (t = Object(t); ++e < u;) { var i = r[e]; i && n(t, i, e, o) } return t }) } function B(n) {
        return function () {
            var t = arguments, r = s(n.prototype), t = n.apply(r, t);
            return X(t) ? t : r
        }
    } function D(n, t, r) { function e() { for (var o = -1, i = arguments.length, c = -1, f = r.length, a = Array(f + i), l = this && this !== wn && this instanceof e ? u : n; ++c < f;)a[c] = r[c]; for (; i--;)a[c++] = arguments[++o]; return l.apply(t, a) } if (typeof n != "function") throw new TypeError("Expected a function"); var u = B(n); return e } function I(n, t, r, e, u, o) {
        var i = -1, c = 1 & u, f = n.length, a = t.length; if (f != a && !(2 & u && a > f)) return false; for (a = true; ++i < f;) {
            var l = n[i], p = t[i]; if (void 0 !== an) { a = false; break } if (c) {
                if (!S(t, function (n) {
                    return l === n || r(l, n, e, u, o);
                })) { a = false; break }
            } else if (l !== p && !r(l, p, e, u, o)) { a = false; break }
        } return a
    } function $(n, t, r) { switch (r) { case "[object Boolean]": case "[object Date]": return +n == +t; case "[object Error]": return n.name == t.name && n.message == t.message; case "[object Number]": return n != +n ? t != +t : n == +t; case "[object RegExp]": case "[object String]": return n == t + "" }return false } function q(n, t, r, e, u, o) {
        var i = 2 & u, c = en(n), f = c.length, a = en(t).length; if (f != a && !i) return false; for (var l = f; l--;) { var p = c[l]; if (!(i ? p in t : En.call(t, p))) return false } for (a = true; ++l < f;) {
            var p = c[l], s = n[p], h = t[p]; if (void 0 !== an || s !== h && !r(s, h, e, u, o)) { a = false; break } i || (i = "constructor" == p)
        } return a && !i && (r = n.constructor, e = t.constructor, r != e && "constructor" in n && "constructor" in t && !(typeof r == "function" && r instanceof r && typeof e == "function" && e instanceof e) && (a = false)), a
    } function z(n) { var t = n ? n.length : an; if (W(t) && (Pn(n) || nn(n) || K(n))) { n = String; for (var r = -1, e = Array(t); ++r < t;)e[r] = n(r); t = e } else t = null; return t } function C(n) { var t = n && n.constructor, t = Q(t) && t.prototype || xn; return n === t } function G(n) {
        return n ? n[0] : an
    } function J(n, t) { return r(n, d(t), $n) } function M(n, t) { return $n(n, typeof t == "function" ? t : cn) } function P(n, t, r) { return e(n, d(t), r, 3 > arguments.length, $n) } function U(n, t) { var r; if (typeof t != "function") throw new TypeError("Expected a function"); return n = Un(n), function () { return 0 < --n && (r = t.apply(this, arguments)), 1 >= n && (t = an), r } } function V(n) {
        var t; if (typeof n != "function") throw new TypeError("Expected a function"); return t = In(t === an ? n.length - 1 : Un(t), 0), function () {
            for (var r = arguments, e = -1, u = In(r.length - t, 0), o = Array(u); ++e < u;)o[e] = r[t + e];
            for (u = Array(t + 1), e = -1; ++e < t;)u[e] = r[e]; return u[t] = o, n.apply(this, u)
        }
    } function H(n, t) { return n > t } function K(n) { return Y(n) && L(n) && En.call(n, "callee") && (!Rn.call(n, "callee") || "[object Arguments]" == kn.call(n)) } function L(n) { return null != n && !(typeof n == "function" && Q(n)) && W(zn(n)) } function Q(n) { return n = X(n) ? kn.call(n) : "", "[object Function]" == n || "[object GeneratorFunction]" == n } function W(n) { return typeof n == "number" && n > -1 && 0 == n % 1 && 9007199254740991 >= n } function X(n) {
        var t = typeof n; return !!n && ("object" == t || "function" == t);
    } function Y(n) { return !!n && typeof n == "object" } function Z(n) { return typeof n == "number" || Y(n) && "[object Number]" == kn.call(n) } function nn(n) { return typeof n == "string" || !Pn(n) && Y(n) && "[object String]" == kn.call(n) } function tn(n, t) { return t > n } function rn(n) { return typeof n == "string" ? n : null == n ? "" : n + "" } function en(n) { var t = C(n); if (!t && !L(n)) return Dn(Object(n)); var r, e = z(n), u = !!e, e = e || [], o = e.length; for (r in n) !En.call(n, r) || u && ("length" == r || f(r, o)) || t && "constructor" == r || e.push(r); return e } function un(n) {
        for (var t = -1, r = C(n), e = w(n), u = e.length, o = z(n), i = !!o, o = o || [], c = o.length; ++t < u;) {
            var a = e[t]; i && ("length" == a || f(a, c)) || "constructor" == a && (r || !En.call(n, a)) || o.push(a)
        } return o
    } function on(n) { return n ? u(n, en(n)) : [] } function cn(n) { return n } function fn(t, r, e) {
        var u = en(r), o = b(r, u); null != e || X(r) && (o.length || !u.length) || (e = r, r = t, t = this, o = b(r, en(r))); var i = X(e) && "chain" in e ? e.chain : true, c = Q(t); return $n(o, function (e) {
            var u = r[e]; t[e] = u, c && (t.prototype[e] = function () {
                var r = this.__chain__; if (i || r) {
                    var e = t(this.__wrapped__); return (e.__actions__ = N(this.__actions__)).push({
                        func: u, args: arguments,
                        thisArg: t
                    }), e.__chain__ = r, e
                } return u.apply(t, n([this.value()], arguments))
            })
        }), t
    } var an, ln = 1 / 0, pn = /[&<>"'`]/g, sn = RegExp(pn.source), hn = /^(?:0|[1-9]\d*)$/, vn = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "`": "&#96;" }, yn = { "function": true, object: true }, _n = yn[typeof exports] && exports && !exports.nodeType ? exports : an, gn = yn[typeof module] && module && !module.nodeType ? module : an, bn = gn && gn.exports === _n ? _n : an, jn = o(yn[typeof self] && self), mn = o(yn[typeof window] && window), dn = o(yn[typeof this] && this), wn = o(_n && gn && typeof global == "object" && global) || mn !== (dn && dn.window) && mn || jn || dn || Function("return this")(), On = Array.prototype, xn = Object.prototype, En = xn.hasOwnProperty, An = 0, kn = xn.toString, Nn = wn._, Sn = wn.Reflect, Tn = Sn ? Sn.f : an, Fn = Object.create, Rn = xn.propertyIsEnumerable, Bn = wn.isFinite, Dn = Object.keys, In = Math.max, $n = function (n, t) {
        return function (r, e) { if (null == r) return r; if (!L(r)) return n(r, e); for (var u = r.length, o = t ? u : -1, i = Object(r); (t ? o-- : ++o < u) && false !== e(i[o], o, i);); return r }
    }(g), qn = function (n) { return function (t, r, e) { var u = -1, o = Object(t); e = e(t); for (var i = e.length; i--;) { var c = e[n ? i : ++u]; if (false === r(o[c], c, o)) break } return t } }(); Tn && !Rn.call({ valueOf: 1 }, "valueOf") && (w = function (n) { n = Tn(n); for (var t, r = []; !(t = n.next()).done;)r.push(t.value); return r }); var zn = A("length"), Cn = V(function (t, r) {
        return Pn(t) || (t = null == t ? [] : [Object(t)]), _(r, 1),
            n(N(t), on)
    }), Gn = V(function (n, t, r) { return D(n, t, r) }), Jn = V(function (n, t) { return h(n, 1, t) }), Mn = V(function (n, t, r) { return h(n, Vn(t) || 0, r) }), Pn = Array.isArray, Un = Number, Vn = Number, Hn = R(function (n, t) { F(t, en(t), n) }), Kn = R(function (n, t) { F(t, un(t), n) }), Ln = R(function (n, t, r, e) { F(t, un(t), n, e) }), Qn = V(function (n) { return n.push(an, p), Ln.apply(an, n) }), Wn = V(function (n, t) { return null == n ? {} : E(n, _(t, 1)) }), Xn = d; l.prototype = s(a.prototype), l.prototype.constructor = l, a.assignIn = Kn, a.before = U, a.bind = Gn, a.chain = function (n) {
        return n = a(n),
            n.__chain__ = true, n
    }, a.compact = function (n) { return y(n, Boolean) }, a.concat = Cn, a.create = function (n, t) { var r = s(n); return t ? Hn(r, t) : r }, a.defaults = Qn, a.defer = Jn, a.delay = Mn, a.filter = function (n, t) { return y(n, d(t)) }, a.flatten = function (n) { return n && n.length ? _(n, 1) : [] }, a.flattenDeep = function (n) { return n && n.length ? _(n, ln) : [] }, a.iteratee = Xn, a.keys = en, a.map = function (n, t) { return O(n, d(t)) }, a.matches = function (n) { return x(Hn({}, n)) }, a.mixin = fn, a.negate = function (n) {
        if (typeof n != "function") throw new TypeError("Expected a function");
        return function () { return !n.apply(this, arguments) }
    }, a.once = function (n) { return U(2, n) }, a.pick = Wn, a.slice = function (n, t, r) { var e = n ? n.length : 0; return r = r === an ? e : +r, e ? k(n, null == t ? 0 : +t, r) : [] }, a.sortBy = function (n, t) {
        var r = 0; return t = d(t), O(O(n, function (n, e, u) { return { c: n, b: r++, a: t(n, e, u) } }).sort(function (n, t) {
            var r; n: { r = n.a; var e = t.a; if (r !== e) { var u = null === r, o = r === an, i = r === r, c = null === e, f = e === an, a = e === e; if (r > e && !c || !i || u && !f && a || o && a) { r = 1; break n } if (e > r && !u || !a || c && !o && i || f && i) { r = -1; break n } } r = 0 } return r || n.b - t.b;
        }), A("c"))
    }, a.tap = function (n, t) { return t(n), n }, a.thru = function (n, t) { return t(n) }, a.toArray = function (n) { return L(n) ? n.length ? N(n) : [] : on(n) }, a.values = on, a.extend = Kn, fn(a, a), a.clone = function (n) { return X(n) ? Pn(n) ? N(n) : F(n, en(n)) : n }, a.escape = function (n) { return (n = rn(n)) && sn.test(n) ? n.replace(pn, i) : n }, a.every = function (n, t, r) { return t = r ? an : t, v(n, d(t)) }, a.find = J, a.forEach = M, a.has = function (n, t) { return null != n && En.call(n, t) }, a.head = G, a.identity = cn, a.indexOf = function (n, t, r) {
        var e = n ? n.length : 0; r = typeof r == "number" ? 0 > r ? In(e + r, 0) : r : 0,
            r = (r || 0) - 1; for (var u = t === t; ++r < e;) { var o = n[r]; if (u ? o === t : o !== o) return r } return -1
    }, a.isArguments = K, a.isArray = Pn, a.isBoolean = function (n) { return true === n || false === n || Y(n) && "[object Boolean]" == kn.call(n) }, a.isDate = function (n) { return Y(n) && "[object Date]" == kn.call(n) }, a.isEmpty = function (n) { if (L(n) && (Pn(n) || nn(n) || Q(n.splice) || K(n))) return !n.length; for (var t in n) if (En.call(n, t)) return false; return true }, a.isEqual = function (n, t) { return j(n, t) }, a.isFinite = function (n) { return typeof n == "number" && Bn(n) }, a.isFunction = Q, a.isNaN = function (n) {
        return Z(n) && n != +n
    }, a.isNull = function (n) { return null === n }, a.isNumber = Z, a.isObject = X, a.isRegExp = function (n) { return X(n) && "[object RegExp]" == kn.call(n) }, a.isString = nn, a.isUndefined = function (n) { return n === an }, a.last = function (n) { var t = n ? n.length : 0; return t ? n[t - 1] : an }, a.max = function (n) { return n && n.length ? t(n, cn, H) : an }, a.min = function (n) { return n && n.length ? t(n, cn, tn) : an }, a.noConflict = function () { return wn._ === this && (wn._ = Nn), this }, a.noop = function () { }, a.reduce = P, a.result = function (n, t, r) {
        return t = null == n ? an : n[t],
            t === an && (t = r), Q(t) ? t.call(n) : t
    }, a.size = function (n) { return null == n ? 0 : (n = L(n) ? n : en(n), n.length) }, a.some = function (n, t, r) { return t = r ? an : t, S(n, d(t)) }, a.uniqueId = function (n) { var t = ++An; return rn(n) + t }, a.each = M, a.first = G, fn(a, function () { var n = {}; return g(a, function (t, r) { En.call(a.prototype, r) || (n[r] = t) }), n }(), { chain: false }), a.VERSION = "4.5.1", $n("pop join replace reverse split push shift sort splice unshift".split(" "), function (n) {
        var t = (/^(?:replace|split)$/.test(n) ? String.prototype : On)[n], r = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", e = /^(?:pop|join|replace|shift)$/.test(n);
        a.prototype[n] = function () { var n = arguments; return e && !this.__chain__ ? t.apply(this.value(), n) : this[r](function (r) { return t.apply(r, n) }) }
    }), a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = function () { return T(this.__wrapped__, this.__actions__) }, (mn || jn || {})._ = a, typeof define == "function" && typeof define.amd == "object" && define.amd ? define(function () { return a }) : _n && gn ? (bn && ((gn.exports = a)._ = a), _n._ = a) : wn._ = a
}).call(this);


/*

    PinchZoom.js
    Copyright (c) Manuel Stofer 2013 - today

    Author: Manuel Stofer (mst@rtp.ch)
    Version: 2.2.0

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
    THE SOFTWARE.

*/

// polyfills
(function () {

    if (typeof Object.assign != 'function') {
        // Must be writable: true, enumerable: false, configurable: true
        Object.defineProperty(Object, "assign", {
            value: function assign(target, varArgs) { // .length of function is 2
                if (target == null) { // TypeError if undefined or null
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                var to = Object(target);

                for (var index = 1; index < arguments.length; index++) {
                    var nextSource = arguments[index];

                    if (nextSource != null) { // Skip over if undefined or null
                        for (var nextKey in nextSource) {
                            // Avoid bugs when hasOwnProperty is shadowed
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
                return to;
            },
            writable: true,
            configurable: true
        });
    }

    if (typeof Array.from != 'function') {
        Array.from = function (object) {
            return [].slice.call(object);
        };
    }

    // utils
    var buildElement = function (str) {
        // empty string as title argument required by IE and Edge
        var tmp = document.implementation.createHTMLDocument('');
        tmp.body.innerHTML = str;
        return Array.from(tmp.body.children)[0];
    };

    var triggerEvent = function (el, name) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(name, true, false);
        el.dispatchEvent(event);
    };

    var definePinchZoom = function () {

        /**
         * Pinch zoom
         * @param el
         * @param options
         * @constructor
         */
        var PinchZoom = function (el, options) {
            this.el = el;
            this.zoomFactor = 1;
            this.lastScale = 1;
            this.offset = {
                x: 0,
                y: 0
            };
            this.initialOffset = {
                x: 0,
                y: 0,
            };
            this.options = Object.assign({}, this.defaults, options);
            this.setupMarkup();
            this.bindEvents();
            this.update();

            // The image may already be loaded when PinchZoom is initialized,
            // and then the load event (which trigger update) will never fire.
            if (this.isImageLoaded(this.el)) {
                this.updateAspectRatio();
                this.setupInitialOffset();
            }

            this.enable();

        },
            sum = function (a, b) {
                return a + b;
            },
            isCloseTo = function (value, expected) {
                return value > expected - 0.01 && value < expected + 0.01;
            };

        PinchZoom.prototype = {

            defaults: {
                tapZoomFactor: 2,
                zoomOutFactor: 1.3,
                animationDuration: 300,
                maxZoom: 4,
                minZoom: 0.5,
                draggableUnzoomed: true,
                lockDragAxis: false,
                use2d: true,
                zoomStartEventName: 'pz_zoomstart',
                zoomUpdateEventName: 'pz_zoomupdate',
                zoomEndEventName: 'pz_zoomend',
                dragStartEventName: 'pz_dragstart',
                dragUpdateEventName: 'pz_dragupdate',
                dragEndEventName: 'pz_dragend',
                doubleTapEventName: 'pz_doubletap',
                verticalPadding: 0,
                horizontalPadding: 0,
            },

            /**
             * Event handler for 'dragstart'
             * @param event
             */
            handleDragStart: function (event) {
                triggerEvent(this.el, this.options.dragStartEventName);
                this.stopAnimation();
                this.lastDragPosition = false;
                this.hasInteraction = true;
                this.handleDrag(event);
            },

            /**
             * Event handler for 'drag'
             * @param event
             */
            handleDrag: function (event) {
                var touch = this.getTouches(event)[0];
                this.drag(touch, this.lastDragPosition);
                this.offset = this.sanitizeOffset(this.offset);
                this.lastDragPosition = touch;
            },

            handleDragEnd: function () {
                triggerEvent(this.el, this.options.dragEndEventName);
                this.end();
            },

            /**
             * Event handler for 'zoomstart'
             * @param event
             */
            handleZoomStart: function (event) {
                triggerEvent(this.el, this.options.zoomStartEventName);
                this.stopAnimation();
                this.lastScale = 1;
                this.nthZoom = 0;
                this.lastZoomCenter = false;
                this.hasInteraction = true;
            },

            /**
             * Event handler for 'zoom'
             * @param event
             */
            handleZoom: function (event, newScale) {
                // a relative scale factor is used
                var touchCenter = this.getTouchCenter(this.getTouches(event)),
                    scale = newScale / this.lastScale;
                this.lastScale = newScale;

                // the first touch events are thrown away since they are not precise
                this.nthZoom += 1;
                if (this.nthZoom > 3) {

                    this.scale(scale, touchCenter);
                    this.drag(touchCenter, this.lastZoomCenter);
                }
                this.lastZoomCenter = touchCenter;
            },

            handleZoomEnd: function () {
                triggerEvent(this.el, this.options.zoomEndEventName);
                this.end();
            },

            /**
             * Event handler for 'doubletap'
             * @param event
             */
            handleDoubleTap: function (event) {
                var center = this.getTouches(event)[0],
                    zoomFactor = this.zoomFactor > 1 ? 1 : this.options.tapZoomFactor,
                    startZoomFactor = this.zoomFactor,
                    updateProgress = (function (progress) {
                        this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
                    }).bind(this);

                if (this.hasInteraction) {
                    return;
                }

                this.isDoubleTap = true;

                if (startZoomFactor > zoomFactor) {
                    center = this.getCurrentZoomCenter();
                }

                this.animate(this.options.animationDuration, updateProgress, this.swing);
                triggerEvent(this.el, this.options.doubleTapEventName);
            },

            /**
             * Compute the initial offset
             *
             * the element should be centered in the container upon initialization
             */
            computeInitialOffset: function () {
                this.initialOffset = {
                    x: -Math.abs(this.el.offsetWidth * this.getInitialZoomFactor() - this.container.offsetWidth) / 2,
                    y: -Math.abs(this.el.offsetHeight * this.getInitialZoomFactor() - this.container.offsetHeight) / 2,
                };
            },

            /**
             * Determine if image is loaded
             */
            isImageLoaded: function (el) {
                if (el.nodeName === 'IMG') {
                    return el.complete && el.naturalHeight !== 0;
                } else {
                    return Array.from(el.querySelectorAll('img')).every(this.isImageLoaded);
                }
            },

            setupInitialOffset: function () {
                if (this._initialOffsetSetup) {
                    return;
                }

                this._initialOffsetSetup = true;

                this.computeInitialOffset();
                this.offset.x = this.initialOffset.x;
                this.offset.y = this.initialOffset.y;
            },

            /**
             * Max / min values for the offset
             * @param offset
             * @return {Object} the sanitized offset
             */
            sanitizeOffset: function (offset) {
                var elWidth = this.el.offsetWidth * this.getInitialZoomFactor() * this.zoomFactor;
                var elHeight = this.el.offsetHeight * this.getInitialZoomFactor() * this.zoomFactor;
                var maxX = elWidth - this.getContainerX() + this.options.horizontalPadding,
                    maxY = elHeight - this.getContainerY() + this.options.verticalPadding,
                    maxOffsetX = Math.max(maxX, 0),
                    maxOffsetY = Math.max(maxY, 0),
                    minOffsetX = Math.min(maxX, 0) - this.options.horizontalPadding,
                    minOffsetY = Math.min(maxY, 0) - this.options.verticalPadding;

                return {
                    x: Math.min(Math.max(offset.x, minOffsetX), maxOffsetX),
                    y: Math.min(Math.max(offset.y, minOffsetY), maxOffsetY)
                };
            },

            /**
             * Scale to a specific zoom factor (not relative)
             * @param zoomFactor
             * @param center
             */
            scaleTo: function (zoomFactor, center) {
                this.scale(zoomFactor / this.zoomFactor, center);
            },

            /**
             * Scales the element from specified center
             * @param scale
             * @param center
             */
            scale: function (scale, center) {
                scale = this.scaleZoomFactor(scale);
                this.addOffset({
                    x: (scale - 1) * (center.x + this.offset.x),
                    y: (scale - 1) * (center.y + this.offset.y)
                });
                triggerEvent(this.el, this.options.zoomUpdateEventName);
            },

            /**
             * Scales the zoom factor relative to current state
             * @param scale
             * @return the actual scale (can differ because of max min zoom factor)
             */
            scaleZoomFactor: function (scale) {
                var originalZoomFactor = this.zoomFactor;
                this.zoomFactor *= scale;
                this.zoomFactor = Math.min(this.options.maxZoom, Math.max(this.zoomFactor, this.options.minZoom));
                return this.zoomFactor / originalZoomFactor;
            },

            /**
             * Determine if the image is in a draggable state
             *
             * When the image can be dragged, the drag event is acted upon and cancelled.
             * When not draggable, the drag event bubbles through this component.
             *
             * @return {Boolean}
             */
            canDrag: function () {
                return this.options.draggableUnzoomed || !isCloseTo(this.zoomFactor, 1);
            },

            /**
             * Drags the element
             * @param center
             * @param lastCenter
             */
            drag: function (center, lastCenter) {
                if (lastCenter) {
                    if (this.options.lockDragAxis) {
                        // lock scroll to position that was changed the most
                        if (Math.abs(center.x - lastCenter.x) > Math.abs(center.y - lastCenter.y)) {
                            this.addOffset({
                                x: -(center.x - lastCenter.x),
                                y: 0
                            });
                        }
                        else {
                            this.addOffset({
                                y: -(center.y - lastCenter.y),
                                x: 0
                            });
                        }
                    }
                    else {
                        this.addOffset({
                            y: -(center.y - lastCenter.y),
                            x: -(center.x - lastCenter.x)
                        });
                    }
                    triggerEvent(this.el, this.options.dragUpdateEventName);
                }
            },

            /**
             * Calculates the touch center of multiple touches
             * @param touches
             * @return {Object}
             */
            getTouchCenter: function (touches) {
                return this.getVectorAvg(touches);
            },

            /**
             * Calculates the average of multiple vectors (x, y values)
             */
            getVectorAvg: function (vectors) {
                return {
                    x: vectors.map(function (v) { return v.x; }).reduce(sum) / vectors.length,
                    y: vectors.map(function (v) { return v.y; }).reduce(sum) / vectors.length
                };
            },

            /**
             * Adds an offset
             * @param offset the offset to add
             * @return return true when the offset change was accepted
             */
            addOffset: function (offset) {
                this.offset = {
                    x: this.offset.x + offset.x,
                    y: this.offset.y + offset.y
                };
            },

            sanitize: function () {
                if (this.zoomFactor < this.options.zoomOutFactor) {
                    this.zoomOutAnimation();
                } else if (this.isInsaneOffset(this.offset)) {
                    this.sanitizeOffsetAnimation();
                }
            },

            /**
             * Checks if the offset is ok with the current zoom factor
             * @param offset
             * @return {Boolean}
             */
            isInsaneOffset: function (offset) {
                var sanitizedOffset = this.sanitizeOffset(offset);
                return sanitizedOffset.x !== offset.x ||
                    sanitizedOffset.y !== offset.y;
            },

            /**
             * Creates an animation moving to a sane offset
             */
            sanitizeOffsetAnimation: function () {
                var targetOffset = this.sanitizeOffset(this.offset),
                    startOffset = {
                        x: this.offset.x,
                        y: this.offset.y
                    },
                    updateProgress = (function (progress) {
                        this.offset.x = startOffset.x + progress * (targetOffset.x - startOffset.x);
                        this.offset.y = startOffset.y + progress * (targetOffset.y - startOffset.y);
                        this.update();
                    }).bind(this);

                this.animate(
                    this.options.animationDuration,
                    updateProgress,
                    this.swing
                );
            },

            /**
             * Zooms back to the original position,
             * (no offset and zoom factor 1)
             */
            zoomOutAnimation: function () {
                if (this.zoomFactor === 1) {
                    return;
                }

                var startZoomFactor = this.zoomFactor,
                    zoomFactor = 1,
                    center = this.getCurrentZoomCenter(),
                    updateProgress = (function (progress) {
                        this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
                    }).bind(this);

                this.animate(
                    this.options.animationDuration,
                    updateProgress,
                    this.swing
                );
            },

            /**
             * Updates the aspect ratio
             */
            updateAspectRatio: function () {
                if (this.container.parentElement) {
                    this.setContainerY(this.container.parentElement.offsetHeight);
                }
            },

            /**
             * Calculates the initial zoom factor (for the element to fit into the container)
             * @return {number} the initial zoom factor
             */
            getInitialZoomFactor: function () {
                var xZoomFactor = this.container.offsetWidth / this.el.offsetWidth;
                var yZoomFactor = this.container.offsetHeight / this.el.offsetHeight;

                return Math.min(xZoomFactor, yZoomFactor);
            },

            /**
             * Calculates the aspect ratio of the element
             * @return the aspect ratio
             */
            getAspectRatio: function () {
                return this.el.offsetWidth / this.el.offsetHeight;
            },

            /**
             * Calculates the virtual zoom center for the current offset and zoom factor
             * (used for reverse zoom)
             * @return {Object} the current zoom center
             */
            getCurrentZoomCenter: function () {
                const offsetLeft = this.offset.x - this.initialOffset.x;
                const centerX = -1 * this.offset.x - offsetLeft / (1 / this.zoomFactor - 1);

                const offsetTop = this.offset.y - this.initialOffset.y;
                const centerY = -1 * this.offset.y - offsetTop / (1 / this.zoomFactor - 1);

                return {
                    x: centerX,
                    y: centerY
                };
            },

            /**
             * Returns the touches of an event relative to the container offset
             * @param event
             * @return array touches
             */
            getTouches: function (event) {
                var rect = this.container.getBoundingClientRect();
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
                var posTop = rect.top + scrollTop;
                var posLeft = rect.left + scrollLeft;

                return Array.prototype.slice.call(event.touches).map(function (touch) {
                    return {
                        x: touch.pageX - posLeft,
                        y: touch.pageY - posTop,
                    };
                });
            },

            /**
             * Animation loop
             * does not support simultaneous animations
             * @param duration
             * @param framefn
             * @param timefn
             * @param callback
             */
            animate: function (duration, framefn, timefn, callback) {
                var startTime = new Date().getTime(),
                    renderFrame = (function () {
                        if (!this.inAnimation) { return; }
                        var frameTime = new Date().getTime() - startTime,
                            progress = frameTime / duration;
                        if (frameTime >= duration) {
                            framefn(1);
                            if (callback) {
                                callback();
                            }
                            this.update();
                            this.stopAnimation();
                            this.update();
                        } else {
                            if (timefn) {
                                progress = timefn(progress);
                            }
                            framefn(progress);
                            this.update();
                            requestAnimationFrame(renderFrame);
                        }
                    }).bind(this);
                this.inAnimation = true;
                requestAnimationFrame(renderFrame);
            },

            /**
             * Stops the animation
             */
            stopAnimation: function () {
                this.inAnimation = false;
            },

            /**
             * Swing timing function for animations
             * @param p
             * @return {Number}
             */
            swing: function (p) {
                return -Math.cos(p * Math.PI) / 2 + 0.5;
            },

            getContainerX: function () {
                return this.container.offsetWidth;
            },

            getContainerY: function () {
                return this.container.offsetHeight;
            },

            setContainerY: function (y) {
                return this.container.style.height = y + 'px';
            },

            /**
             * Creates the expected html structure
             */
            setupMarkup: function () {
                this.container = buildElement('<div class="pinch-zoom-container"></div>');
                this.el.parentNode.insertBefore(this.container, this.el);
                this.container.appendChild(this.el);
                var $image = '';
                if (this.el.nodeName !== 'IMG') {
                    $image = $(this.el).find('img:first');
                } else {
                    $image = this.el
                }
                this.container.style.overflow = 'hidden';
                this.container.style.position = 'relative';
                var slicklist = this.el.closest('div.slick-list');
                var slickSlide = this.el.closest('li.slick-slide');
                var test = this;
                if (slicklist && slickSlide) {
                    this.container.style.height = slicklist.style.height;
                    this.container.style.width = slickSlide.style.width;
                    this.el.style.height = slicklist.style.height;
                    this.el.style.width = slickSlide.style.width;
                } else {
                    this.container.style.height = this.el.clientHeight + "px";
                    this.container.style.width = this.el.clientWidth + "px";
                    this.el.style.height = this.el.clientHeight + "px";
                    this.el.style.width = this.el.clientWidth + "px";
                }
                this.el.style.webkitTransformOrigin = '0% 0%';
                this.el.style.mozTransformOrigin = '0% 0%';
                this.el.style.msTransformOrigin = '0% 0%';
                this.el.style.oTransformOrigin = '0% 0%';
                this.el.style.transformOrigin = '0% 0%';
                this.el.style.position = 'absolute';
            },

            end: function () {
                this.hasInteraction = false;
                this.sanitize();
                this.update();
            },

            /**
             * Binds all required event listeners
             */
            bindEvents: function () {
                var self = this;
                detectGestures(this.container, this);

                window.addEventListener('resize', this.update.bind(this));
                Array.from(this.el.querySelectorAll('img')).forEach(function (imgEl) {
                    imgEl.addEventListener('load', self.update.bind(self));
                });

                if (this.el.nodeName === 'IMG') {
                    this.el.addEventListener('load', this.update.bind(this));
                }
            },

            /**
             * Updates the css values according to the current zoom factor and offset
             */
            update: function (event) {
                if (this.updatePlaned) {
                    return;
                }
                this.updatePlaned = true;

                window.setTimeout((function () {
                    this.updatePlaned = false;
                    this.updateAspectRatio();

                    if (event && event.type === 'resize') {
                        this.computeInitialOffset();
                    }

                    if (event && event.type === 'load') {
                        this.setupInitialOffset();
                    }

                    var zoomFactor = (this.zoomFactor === 1) ? this.zoomFactor : this.getInitialZoomFactor() * this.zoomFactor;
                    var offsetX = (this.zoomFactor === 1) ? 0 : -this.offset.x / zoomFactor,
                        offsetY = (this.zoomFactor === 1) ? 0 : -this.offset.y / zoomFactor;

                    transform3d = 'scale3d(' + zoomFactor + ', ' + zoomFactor + ',1) ' +
                        'translate3d(' + offsetX + 'px,' + offsetY + 'px,0px)',
                        transform2d = 'scale(' + zoomFactor + ', ' + zoomFactor + ') ' +
                        'translate(' + offsetX + 'px,' + offsetY + 'px)',
                        removeClone = (function () {
                            if (this.clone) {
                                this.clone.parentNode.removeChild(this.clone);
                                delete this.clone;
                            }
                        }).bind(this);

                    // Scale 3d and translate3d are faster (at least on ios)
                    // but they also reduce the quality.
                    // PinchZoom uses the 3d transformations during interactions
                    // after interactions it falls back to 2d transformations
                    if (!this.options.use2d || this.hasInteraction || this.inAnimation) {
                        this.is3d = true;
                        removeClone();

                        this.el.style.webkitTransform = transform3d;
                        this.el.style.mozTransform = transform2d;
                        this.el.style.msTransform = transform2d;
                        this.el.style.oTransform = transform2d;
                        this.el.style.transform = transform3d;
                    } else {
                        // When changing from 3d to 2d transform webkit has some glitches.
                        // To avoid this, a copy of the 3d transformed element is displayed in the
                        // foreground while the element is converted from 3d to 2d transform
                        if (this.is3d) {
                            this.clone = this.el.cloneNode(true);
                            this.clone.style.pointerEvents = 'none';
                            this.container.appendChild(this.clone);
                            window.setTimeout(removeClone, 200);
                        }

                        this.el.style.webkitTransform = transform2d;
                        this.el.style.mozTransform = transform2d;
                        this.el.style.msTransform = transform2d;
                        this.el.style.oTransform = transform2d;
                        this.el.style.transform = transform2d;

                        this.is3d = false;
                    }
                }).bind(this), 0);
            },

            /**
             * Enables event handling for gestures
             */
            enable: function () {
                this.enabled = true;
            },

            /**
             * Disables event handling for gestures
             */
            disable: function () {
                this.enabled = false;
            }
        };

        var detectGestures = function (el, target) {
            var interaction = null,
                fingers = 0,
                lastTouchStart = null,
                startTouches = null,

                setInteraction = function (newInteraction, event) {
                    if (interaction !== newInteraction) {

                        if (interaction && !newInteraction) {
                            switch (interaction) {
                                case "zoom":
                                    target.handleZoomEnd(event);
                                    break;
                                case 'drag':
                                    target.handleDragEnd(event);
                                    break;
                            }
                        }

                        switch (newInteraction) {
                            case 'zoom':
                                target.handleZoomStart(event);
                                break;
                            case 'drag':
                                target.handleDragStart(event);
                                break;
                        }
                    }
                    interaction = newInteraction;
                },

                updateInteraction = function (event) {
                    if (fingers === 2) {
                        setInteraction('zoom');
                    } else if (fingers === 1 && target.canDrag()) {
                        setInteraction('drag', event);
                    } else {
                        setInteraction(null, event);
                    }
                },

                targetTouches = function (touches) {
                    return Array.from(touches).map(function (touch) {
                        return {
                            x: touch.pageX,
                            y: touch.pageY
                        };
                    });
                },

                getDistance = function (a, b) {
                    var x, y;
                    x = a.x - b.x;
                    y = a.y - b.y;
                    return Math.sqrt(x * x + y * y);
                },

                calculateScale = function (startTouches, endTouches) {
                    var startDistance = getDistance(startTouches[0], startTouches[1]),
                        endDistance = getDistance(endTouches[0], endTouches[1]);
                    return endDistance / startDistance;
                },

                cancelEvent = function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                },

                detectDoubleTap = function (event) {
                    var time = (new Date()).getTime();

                    if (fingers > 1) {
                        lastTouchStart = null;
                    }

                    if (time - lastTouchStart < 300) {
                        cancelEvent(event);

                        target.handleDoubleTap(event);
                        switch (interaction) {
                            case "zoom":
                                target.handleZoomEnd(event);
                                break;
                            case 'drag':
                                target.handleDragEnd(event);
                                break;
                        }
                    } else {
                        target.isDoubleTap = false;
                    }

                    if (fingers === 1) {
                        lastTouchStart = time;
                    }
                },
                firstMove = true;

            el.addEventListener('touchstart', function (event) {
                if (target.enabled) {
                    firstMove = true;
                    fingers = event.touches.length;
                    detectDoubleTap(event);
                }
            });

            el.addEventListener('touchmove', function (event) {
                if (target.enabled && !target.isDoubleTap) {
                    if (firstMove) {
                        updateInteraction(event);
                        if (interaction) {
                            cancelEvent(event);
                        }
                        startTouches = targetTouches(event.touches);
                    } else {
                        switch (interaction) {
                            case 'zoom':
                                target.handleZoom(event, calculateScale(startTouches, targetTouches(event.touches)));
                                break;
                            case 'drag':
                                target.handleDrag(event);
                                break;
                        }
                        if (interaction) {
                            cancelEvent(event);
                            target.update();
                        }
                    }

                    firstMove = false;
                }
            });

            el.addEventListener('touchend', function (event) {
                if (target.enabled) {
                    fingers = event.touches.length;
                    updateInteraction(event);
                }
            });
        };

        return PinchZoom;
    };

    if (typeof define !== 'undefined' && define.amd) {
        define(['jquery', 'underscore'], function ($, _) {
            return definePinchZoom($, _);
        });
    } else {
        window.RTP = window.RTP || {};
        (function () {
            var checkjQuery = function () {
                if (window.jQuery) {
                    window.RTP.PinchZoom = definePinchZoom(jQuery, _);
                } else {
                    setTimeout(checkjQuery, 100);
                }
            };
            checkjQuery();
        })();
    }
}).call(this);






/* PINCHJOOM END HERE */


(function () {
    var checkjQuery = function () {
        if (window.jQuery) {

            (function ($) {
                "use strict";
                $.fn.extend({
                    extm: function extm(userOptions) {
                        //merge default and user options to 'options' var
                        var defaultOptions = {
                            zoomElement: false,
                            imageSrc: $(this).attr('src'),
                            squareOverlay: false,
                            position: false,
                            rightPad: 0,
                            lazy: false,
                            zoomLevel: 1,
                            zoomSize: false,
                            loadingText: false,
                            loadingImage: false
                        };
                        var options = $.extend({}, defaultOptions, userOptions || {});
                        function extmInit(options, imageElement) {
                            var smallWidth = imageElement.width();
                            var smallHeight = imageElement.height();
                            var offset = imageElement.offset();
                            var zoomElement;
                            if (!options.zoomElement) {
                                zoomElement = $("<div style='overflow:hidden;pointer-events:none;height:" + smallHeight + "px;width:" + smallWidth + "px;' class='extm'></div>");
                                if (options.position === 'right') {
                                    zoomElement.appendTo($('body'));
                                    zoomElement.css("position", "absolute");
                                    zoomElement.css("top", offset.top);
                                    zoomElement.css("left", offset.left + smallWidth + options.rightPad);
                                }
                                else if (options.position === 'overlay') {
                                    zoomElement.appendTo($('body'));
                                    zoomElement.css("position", "absolute");
                                    zoomElement.css("top", offset.top);
                                    zoomElement.css("left", offset.left);
                                }
                                else {
                                    zoomElement.insertAfter(imageElement);
                                }
                            }
                            else {
                                zoomElement = options.zoomElement;
                            }
                            var overlayElement;
                            var innerOverlayElement;
                            if (options.squareOverlay) {
                                overlayElement = $("<div class='overlayElement' style='pointer-events:none;height:" + smallHeight + "px;width:" + smallWidth + "px;position:absolute;top:" + offset.top + "px;left:" + offset.left + "px;'></div>");
                                $('body').append(overlayElement);
                                innerOverlayElement = $("<div style='background-color:rgba(0,0,0,0.2);position:absolute;' class='innerOverlay'></div>");
                                overlayElement.append(innerOverlayElement);
                            }
                            if (!options.lazy) {
                                zoomElement.css("visibility", "hidden"); //hide zoom holder
                                if (options.squareOverlay) {
                                    innerOverlayElement.css("visibility", "hidden"); //hide zoom holder
                                }
                            }
                            if (options.zoomSize) {
                                var fullSizeImage = $('<img style="position:relative;max-width:none;width:' + options.zoomSize + 'px;">'); //make a large clone and insert it
                            }
                            else if (options.zoomLevel !== 1) {
                                var fullSizeImage = $('<img style="position:relative;max-width:none;width:' + (100 * options.zoomLevel) + '%;">'); //make a large clone and insert it
                            }
                            else {
                                var fullSizeImage = $('<img style="position:relative;max-width:none;">'); //make a large clone and insert it
                            }
                            if (options.imageSrc) {
                                fullSizeImage.attr('src', options.imageSrc);
                            }
                            else {
                                fullSizeImage.attr('src', imageElement.attr('src'));
                            }

                            fullSizeImage.appendTo(zoomElement);
                            //using this closure to make sure the function gets the right 'imageElement' - in case there are many zooms per page
                            (function (imageElement, zoomElement, fullSizeImage, overlayElement, smallHeight, smallWidth, offset, innerOverlayElement, options) {

                                //while we wait for fullsize to load...
                                if (options.loadingText) {
                                    var loadingElement = $("<div class='loadingElement' style='pointer-events:none;height:" + smallHeight + "px;width:" + smallWidth + "px;font-family:sans-serif;position:absolute;top:" + offset.top + "px;left:" + offset.left + "px;visibility:hidden;background:rgba(255,255,255,0.5);color:black;font-size:2em;font-weight:bold;text-align:center;'><p style='position: absolute; left: 50%;top: 50%;transform: translate(-50%, -50%);'>" + options.loadingText + "</p></div>");
                                    $('body').append(loadingElement);
                                    imageElement.on('mouseenter', function () {
                                        loadingElement.css("visibility", "visible");
                                    });
                                    imageElement.on('mouseleave', function () {
                                        loadingElement.css("visibility", "hidden");
                                    });
                                    if (imageElement.is(':hover')) {
                                        imageElement.trigger("mouseenter");
                                    }
                                }
                                else if (options.loadingImage) {
                                    var loadingElement = $("<div class='loadingElement' style='pointer-events:none;height:" + smallHeight + "px;width:" + smallWidth + "px;font-family:sans-serif;position:absolute;top:" + offset.top + "px;left:" + offset.left + "px;visibility:hidden;background:rgba(255,255,255,0.5);color:black;font-size:2em;font-weight:bold;text-align:center;'><img style='position: absolute; left: 50%;top: 50%;transform: translate(-50%, -50%);' src='" + options.loadingImage + "'/></div>");
                                    $('body').append(loadingElement);
                                    imageElement.on('mouseenter', function () {
                                        loadingElement.css("visibility", "visible");
                                    });
                                    imageElement.on('mouseleave', function () {
                                        loadingElement.css("visibility", "hidden");
                                    });
                                    if (imageElement.is(':hover')) {
                                        imageElement.trigger("mouseenter");
                                    }
                                }

                                fullSizeImage.on('load', function () {

                                    if (options.loadingText || options.loadingImage) {
                                        //remove our loading stuff
                                        imageElement.trigger("mouseleave");
                                        imageElement.unbind('mouseenter mouseleave');
                                        loadingElement.remove();
                                    }

                                    imageElement.on('mouseenter', function () { //show/hide functionality
                                        //before we show the zoom element, lets make sure everything is still lined up 
                                        //this is here in case things have moved since init, like if the user changed their browser width and things shuffled
                                        offset = imageElement.offset();
                                        if (options.position === 'right') {
                                            zoomElement.css("top", offset.top);
                                            zoomElement.css("left", offset.left + smallWidth + options.rightPad);
                                        }
                                        else if (options.position === 'overlay') {
                                            zoomElement.css("top", offset.top);
                                            zoomElement.css("left", offset.left);
                                        }
                                        if (options.squareOverlay) {
                                            overlayElement.css("top", offset.top);
                                            overlayElement.css("left", offset.left);
                                        }
                                        zoomElement.css("visibility", "visible");
                                        if (options.squareOverlay) {
                                            innerOverlayElement.css("visibility", "visible");
                                        }
                                    });
                                    imageElement.on('mouseleave', function () {
                                        zoomElement.css("visibility", "hidden");
                                        if (options.squareOverlay) {
                                            innerOverlayElement.css("visibility", "hidden");
                                        }
                                    });
                                    if (imageElement.is(':hover')) {
                                        imageElement.trigger("mouseenter");
                                    }
                                    var fullSizeWidth = fullSizeImage.width(); //declare all of our vars... ratios and heights
                                    var fullSizeHeight = fullSizeImage.height();
                                    var wRatio = fullSizeWidth / smallWidth;
                                    var hRatio = fullSizeHeight / smallHeight;
                                    var wDifference = 0 - (fullSizeWidth - zoomElement.width());
                                    var hDifference = 0 - (fullSizeHeight - zoomElement.height());
                                    if (options.squareOverlay) {
                                        var innerOverlayW = (smallWidth / fullSizeWidth) * smallWidth;
                                        var innerOverlayH = (smallHeight / fullSizeHeight) * smallHeight;
                                        innerOverlayElement.css('height', innerOverlayH);
                                        innerOverlayElement.css('width', innerOverlayW);
                                    }
                                    imageElement.on('mousemove', function (event) { //on mousemove, use ratios and heights to move appropriately
                                        offset = imageElement.offset();
                                        var setTop = smallHeight / 2 - (event.pageY - offset.top) * hRatio;
                                        setTop = Math.max(setTop, hDifference);
                                        setTop = Math.min(setTop, 0);
                                        var setLeft = smallWidth / 2 - (event.pageX - offset.left) * wRatio;
                                        setLeft = Math.max(setLeft, wDifference);
                                        setLeft = Math.min(setLeft, 0);
                                        fullSizeImage.css('top', setTop);
                                        fullSizeImage.css('left', setLeft);
                                        if (options.squareOverlay) {
                                            var squareTop = (event.pageY - offset.top) - innerOverlayElement.height() / 2;
                                            squareTop = Math.max(squareTop, 0);
                                            squareTop = Math.min(squareTop, smallHeight - innerOverlayElement.height());
                                            var squareLeft = (event.pageX - offset.left) - innerOverlayElement.width() / 2;
                                            squareLeft = Math.max(squareLeft, 0);
                                            squareLeft = Math.min(squareLeft, smallWidth - innerOverlayElement.width());
                                            innerOverlayElement.css('top', squareTop);
                                            innerOverlayElement.css('left', squareLeft);
                                        }
                                    });
                                });

                            }(imageElement, zoomElement, fullSizeImage, overlayElement, smallHeight, smallWidth, offset, innerOverlayElement, options));

                            //destroy listener
                            imageElement.on('extmdestroy', function () {
                                zoomElement.remove();
                                if (options.squareOverlay) {
                                    overlayElement.remove();
                                }
                            });

                            //update image
                            imageElement.on('updateImage', function (event, newUrl) {
                                fullSizeImage.attr('src', newUrl);
                            });
                        }
                        if (options.lazy) {
                            if ($(this).width() > 10 && $(this).height() > 10) {
                                $(this).one('mouseenter', function () {
                                    extmInit(options, $(this));
                                });
                            }
                            else {
                                $(this).one('load', function () {
                                    $(this).one('mouseenter', function () {
                                        extmInit(options, $(this));
                                    });
                                });
                            }
                        }
                        else {
                            if ($(this).width() > 10 && $(this).height() > 10) {
                                extmInit(options, $(this));
                            }
                            else {
                                $(this).one('load', function () {
                                    extmInit(options, $(this));
                                });
                            }
                        }
                    },
                    extmDestroy: function extmDestroy() {
                        $(this).trigger('extmdestroy');
                    },
                    extmImageUpdate: function (newUrl) {
                        $(this).trigger('updateImage', newUrl);
                    }
                });
            }(jQuery));

        } else {
            setTimeout(checkjQuery, 100);
        }
    };
    checkjQuery();
})();

document.addEventListener('DOMContentLoaded', function () {
    const playButton = document.getElementById('play-btn');
    const videos = document.querySelectorAll('video');
    videos.forEach(video => {
        video.setAttribute('loop', '');
        playButton.click();

        playButton.addEventListener('click', function () {
            //alert('playing');
            video.play();
        });

        video.play().catch(function (error) {
            console.log('Failed to play the video: ' + error.message);
        });

    });
});

(function () {
    var checkjQuery = function () {
        if (window.jQuery) {

            $(document).ready(function () {

                if ($(window).width() >= 767) {
                    var ZOOM_FACTOR = 2.4;

                    function initDesktopZoom(wrapper) {
                        var img = wrapper.querySelector('img');
                        if (!img) return;

                        wrapper.addEventListener('mouseenter', function () {
                            wrapper.classList.add('zoomed');
                            img.style.setProperty('--zoom-scale', ZOOM_FACTOR);
                        });

                        wrapper.addEventListener('mousemove', function (e) {
                            var rect = wrapper.getBoundingClientRect();
                            var xPct = (e.clientX - rect.left) / rect.width;
                            var yPct = (e.clientY - rect.top) / rect.height;

                            var maxX = rect.width * (ZOOM_FACTOR - 1);
                            var maxY = rect.height * (ZOOM_FACTOR - 1);

                            img.style.setProperty('--zoom-x', -(xPct * maxX) + 'px');
                            img.style.setProperty('--zoom-y', -(yPct * maxY) + 'px');
                        });

                        wrapper.addEventListener('mouseleave', function () {
                            wrapper.classList.remove('zoomed');
                            img.style.setProperty('--zoom-scale', '1');
                            img.style.setProperty('--zoom-x', '0px');
                            img.style.setProperty('--zoom-y', '0px');
                        });
                    }

                    document.querySelectorAll('#Slider-Gallery-custom--desktop .product__media-item .product__media').forEach(initDesktopZoom);
                }


                if ($(window).width() <= 767) {

                    var owl = $('#Slider-Gallery-custom');
                    var owlInstance;
                    (function () {
                        var checkOwlCarousel = function () {
                            if (typeof $.fn.owlCarousel !== 'undefined') {
                                owlInstance = owl.owlCarousel({
                                    loop: true,
                                    nav: false,
                                    dots: true,
                                    responsiveClass: true,
                                    onTranslated: playPauseVideo,
                                    responsive: {
                                        0: {
                                            items: 1,
                                        }
                                    },
                                    onInitialized: function () {
                                        resetZoom();
                                        // Reset zoom when Owl Carousel is initialized
                                    },
                                    onChanged: function (event) {
                                        resetZoom();
                                        // Reset zoom when Owl Carousel slides change
                                    }
                                });
                            } else {
                                setTimeout(checkOwlCarousel, 100); // Check again after 100ms
                            }
                        };
                        checkOwlCarousel();
                    })();


                    document.querySelectorAll('#Slider-Gallery-custom .image-wrapper').forEach(function (carouselElement) {

                        //  var $element = $(this)[0];
                        new window.RTP.PinchZoom(carouselElement, {
                            maxZoom: 5,
                            use2d: !1,
                            draggableUnzoomed: !1
                        })


                    });


                    /*
                    document.querySelectorAll('#Slider-Gallery-custom .product__media img').forEach(function(carouselElement) {
                        var hammer = new Hammer(carouselElement, {
                            touchAction: 'pan-y'
                        });
                        hammer.get('pinch').set({ enable: true });
                    
                        var currentScale = 1;
                        var lastScale = 1;
                        var posX = 0;
                        var posY = 0;
                    
                        hammer.on('pinch', function(e) {
                            var scale = e.scale;
                            var newScale = scale * lastScale;
                            carouselElement.style.transform = 'scale(' + newScale + ') translate(' + posX + 'px, ' + posY + 'px)';
                            // Disable Owl Carousel swipe when zoomed in
                            if (newScale !== 1) {
                                owlInstance.trigger('dragstart.owl');
                            }
                        });
                    
                        hammer.on('panstart', function(ev) {
                            // Disable dragging
                        });
                    
                        hammer.on('panmove', function(ev) {
                            // Disable dragging
                        });
                    
                        hammer.on('panend', function(ev) {
                            // Disable dragging
                        });
                    
                        hammer.on('pinchend', function(e) {
                            lastScale *= e.scale;
                            currentScale = lastScale;
                            // Enable Owl Carousel swipe when zoom level is back to 1
                            if (currentScale === 1) {
                                owlInstance.trigger('dragend.owl');
                                isZoomed = false;
                                enablePageScroll();
                            }
                        });
                    
                        carouselElement.addEventListener('dblclick', function() {
                            var newScale = currentScale === 1 ? 2 : 1;
                            carouselElement.style.transform = 'scale(' + newScale + ')';
                            currentScale = newScale;
                            lastScale = newScale;
                            // Disable Owl Carousel swipe when zoomed in
                            if (newScale !== 1) {
                                owlInstance.trigger('dragstart.owl');
                                isZoomed = true;
                                disablePageScroll();
                            } else {
                                owlInstance.trigger('dragend.owl');
                                isZoomed = false;
                                enablePageScroll();
                            }
                        });
                    
                    });
                    */





                    function playPauseVideo(event) {
                        var currentSlide = $(event.target).find('.owl-item.active');
                        var video = currentSlide.find('span.deferred-media__poster-button.motion-reduce');
                        if (video) {
                            video.click();
                        } else {
                            // No video element found, do nothing
                        }
                    }


                    function resetZoom() {


                        document.querySelectorAll('#Slider-Gallery-custom .product__media img').forEach(function (carouselElement) {
                            carouselElement.style.transform = 'scale(1) translate(0px, 0px)';
                        });
                    }

                    function disablePageScroll() {
                        document.body.addEventListener('touchmove', preventDefault, { passive: false });
                        document.body.addEventListener('wheel', preventDefault, { passive: false });
                        document.body.style.overflow = 'hidden';
                    }

                    function enablePageScroll() {
                        document.body.removeEventListener('touchmove', preventDefault);
                        document.body.removeEventListener('wheel', preventDefault);
                        document.body.style.overflow = '';
                    }

                    function preventDefault(e) {
                        e.preventDefault();
                    }


                }


            });

        } else {
            setTimeout(checkjQuery, 100);
        }
    };
    checkjQuery();
})();
